import * as React from 'react'

import Select from 'airship/patterns/select'
import {Props as SelectProps} from 'airship/patterns/select/Select'
import {RefProp} from 'airship/patterns/types'

import ErrorDisplay from './ErrorDisplay'
import Label, {Props as LabelProps} from './Label'

export type Props = LabelProps & SelectProps & {showError?: boolean}

const ValidatedSelect: React.FC<RefProp<HTMLSelectElement, Props>> = ({
  label,
  id,
  showError = true,
  ...selectProps
}) => {
  return (
    <Label label={label} id={id}>
      <Select {...selectProps} />
      {showError && <ErrorDisplay id={id} />}
    </Label>
  )
}

// eslint-disable-next-line react/display-name
export default React.forwardRef<HTMLSelectElement, Props>((props, ref) => (
  <ValidatedSelect elementRef={ref} {...props} />
))
